import { render } from "./HeroLayout.vue?vue&type=template&id=df76c1c2"
import script from "./HeroLayout.vue?vue&type=script&lang=js"
export * from "./HeroLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__